import React from 'react'

const TheStory = (props) => {

    return (
        <section className="history-section section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col col-xl-6 col-lg-8 col-md-10 col-12">
                        <div className="section-title-s3">
                            <div className="icon">
                                <i className="fi flaticon-suitcase"></i>
                            </div>
                            <span>Story</span>
                            <h2>The Story of Us</h2>
                            <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero sit amet adipiscing</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col col-xl-8 col-lg-10 col-12">
                        <div className="history-grids">
                            <div className="grid grid-s1 clearfix">
                                <div className="time-title">
                                    <h3>2011</h3>
                                    <h4>Started The Company</h4>
                                </div>
                                <div className="details">
                                    <p>Fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arme againg</p>
                                </div>
                            </div>
                            <div className="grid grid-s2 clearfix">
                                <div className="details">
                                    <p>Fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arme againg</p>
                                </div>
                                <div className="time-title">
                                    <h3>2013</h3>
                                    <h4>Reach a milestone</h4>
                                </div>
                            </div>
                            <div className="grid grid-s1 clearfix">
                                <div className="time-title">
                                    <h3>2015</h3>
                                    <h4>Win a Big Award</h4>
                                </div>
                                <div className="details">
                                    <p>Fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arme againg</p>
                                </div>
                            </div>
                            <div className="grid grid-s2 clearfix">
                                <div className="details">
                                    <p>Fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arme againg</p>
                                </div>
                                <div className="time-title">
                                    <h3>2017</h3>
                                    <h4>Add a Foren Office</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TheStory;